import { gql } from "@apollo/client";

export const GET_CONSULTA_CIERRE = gql`
query consultaCierre($mes: Int!, $anio: Int!) {
    consultaCierre(mes: $mes, anio: $anio) { 
        valorEsperado {
            factura_Codigo
            organizacion_ventas
            fechaDesde
            fechaHasta
            fecha
            zona_ventas_Codigo
            zona_ventas_Nombre
            oficina_ventas
            delegacion
            creado_por
            factura_Referencia_Anul
            factura_Clase
            solicitante_Codigo
            solicitante_Nombre
            solicitante_Ramo
            solicitante_Region
            factura_Cantidad
            material_Codigo
            material_Descripcion
            remito_Referencia
            remito_Clase
            centro
            tipo_Pedido
            material_Tipo
            material_Sub_Tipo
            seReporta
            material_Cantidad
            importe_unitario
            material_Total_Neto
            factura_IVA
            factura_Referencia
            grupo_Imp_Cliente
            grupo_Cliente
            cod_Cliente_Destinatario
            cliente_Destinatario
            pacienteActivo
            documento_Ventas
            ivaPaciente
            descIvaPaciente
        }
    }
}`;